module.exports = __webpack_public_path__ + "img/icon-rewards.0c72b63c.svg";